// extracted by mini-css-extract-plugin
module.exports = {"RemixPublished":"RemixComment_RemixPublished__e6CSu","ThumbnailImage":"RemixComment_ThumbnailImage___6BcE","PublishText":"RemixComment_PublishText__Yw6MQ"};